import type { OriginPageName } from '~/types/Segment/SegmentEventLibrary/SegmentEventLibraryBucketList'

export function useCuratorAddGetOriginPage(route: ReturnType<typeof useRoute>) {
  function getOriginPage(): OriginPageName | null {
    if (route.path.includes('draft/')) {
      return route.path.includes('influencers/lists/') ||
        route.query.selectedTab === '1'
        ? 'catalog-lists-tab'
        : 'catalog-curators-tab'
    }

    if (route.path.includes('agency/favorites')) return 'lists-dashboard'

    if (route.path.includes('influencer/profile')) return 'curator-profile'

    if (route.path.includes('influencer/list/')) return 'seo-listing'

    return null
  }

  return {
    getOriginPage,
  }
}
